// // Use $ instead of jQuery without replacing global $
(function ($) {
  var winWidth = $(window).outerWidth();

  $(document).ready(function () {

    var body_attr1, all;
    all = "All";

    function product_link() {
      setTimeout(function () {
        body_attr1 = $('body').attr('data-region');

        // Show Page if Geo location is different
        $('.product-slider .inner-tab-slider .inner-item .col-four').removeClass('New');

        $('.product-slider .inner-tab-slider .inner-item').find('.col-four').each(function () {

          if ($(this).hasClass('Australia') && (body_attr1 === 'australia') || $(this).hasClass('all')) {
            $(this).addClass("active");
          } else if ($(this).hasClass('Zealand') && (body_attr1 == 'new_zealand') || $(this).hasClass('all')) {
            $(this).addClass("active");

          } else if ($(this).hasClass('India') && (body_attr1 == 'in') || $(this).hasClass('all')) {
            $(this).addClass("active");

          } else if ($(this).hasClass('Africa') && (body_attr1 == 'africa') || $(this).hasClass('all')) {
            $(this).addClass("active");

          } else if ($(this).hasClass('Mexico') && (body_attr1 == 'mexico') || $(this).hasClass('all')) {
            $(this).addClass("active");

          } else if ($(this).hasClass('China') && (body_attr1 == 'china') || $(this).hasClass('all')) {
            $(this).addClass("active");

          } else if ($(this).hasClass('ExcludeChina') && (body_attr1 != 'china') || $(this).hasClass('all')) {
            $(this).addClass("active");

          }else {
            $(this).remove();
          }
        });

        $('.product-slider .slider-outer .slider-for .item .inner-tab-slider .inner-item').each(function () {
          var $item_length = $(this).find('.col-four').length;
          if ($item_length == 0) {
            $(this).addClass("no-content");
            $(this).remove();
          }
          else {
            $(this).removeClass("no-content");
          }
        });

      }, 500);
    }

    product_link();

    $('.product-slider .slider-for').slick({
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      infinite: false,
      speed: 800,
      draggable: false,
      adaptiveHeight: true,
      asNavFor: '.product-slider .slider-nav',
      prevArrow: $('.product-slider .slide-nav .slide-prev'),
      nextArrow: $('.product-slider .slide-nav .slide-next'),
    });


    var $item = $('.product-slider .slider-nav .item').length;
    if ($item <= 8) {
      $('.product-slider .slider-nav').slick({
        arrows: false,
        slidesToShow: $item,
        slidesToScroll: 1,
        asNavFor: '.product-slider .slider-for',
        infinite: false,
        draggable: false,
        speed: 800,
        dots: false,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 7,
              swipeToSlide: true,
              draggable: true
            }
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 5,
              swipeToSlide: true,
              draggable: true
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3,
              swipeToSlide: true,
              draggable: true,
              // centerMode: true
            }
          },
          {
            breakpoint: 595,
            settings: {
              slidesToShow: 3,
              swipeToSlide: true,
              draggable: true,
              // centerMode: true
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              swipeToSlide: true,
              draggable: true,
              // centerMode: true
            }
          }
        ]
      });
    }
    else {
      $('.product-slider .slider-nav').slick({
        arrows: false,
        slidesToShow: 8,
        slidesToScroll: 1,
        asNavFor: '.product-slider .slider-for',
        infinite: false,
        draggable: false,
        speed: 800,
        dots: false,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 7,
              swipeToSlide: true,
              draggable: true
            }
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 5,
              swipeToSlide: true,
              draggable: true
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3,
              swipeToSlide: true,
              draggable: true,
              // centerMode: true
            }
          },
          {
            breakpoint: 595,
            settings: {
              slidesToShow: 3,
              swipeToSlide: true,
              draggable: true,
              // centerMode: true
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              swipeToSlide: true,
              draggable: true,
              // centerMode: true
            }
          }
        ]
      });
    }

    setTimeout(function () {
      $('.product-slider .inner-tab-slider .inner-wrap').slick({
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        draggable: true,
        speed: 800,
        dots: true,
      });
    }, 600);


    var item_length = $('body .product-slider .slider-wrap .slider-nav .item').length - 1;

    function setArrow() {
        if ($('.product-slider .slider-wrap .slide-nav .slide-next').hasClass('slick-disabled')) {
          $('body .product-slider .slider-wrap .slide-nav .last').addClass('slick-disabled');
        }else {
          $('body .product-slider .slider-wrap .slide-nav .last').removeClass('slick-disabled');
        }

        if ($('.product-slider .slider-wrap .slide-nav .slide-prev').hasClass('slick-disabled')) {
          $('body .product-slider .slider-wrap .slide-nav .first').addClass('slick-disabled');
        }else {
          $('body .product-slider .slider-wrap .slide-nav .first').removeClass('slick-disabled');
        }
    }

    setArrow();

    $('.product-slider .slider-wrap').on('swipe', function (event, slick, direction) {
      setArrow();
    });

    $('.product-slider .slider-wrap .slider-nav .item').on('click', function () {
      setArrow();
    });

    $('.product-slider .slider-wrap .slide-nav .first').on('click', function () {
      $('body .product-slider .slider-wrap .slider-nav .item:eq(0)').trigger('click');
      setArrow();
    });

    $('.product-slider .slider-wrap .slide-nav .last').on('click', function () {
      $('body .product-slider .slider-wrap .slider-nav .item:eq( ' + item_length + ')').trigger('click');
      setArrow();
    });


    $('body .product-slider .slider-wrap .slide-nav .slide-next').on('click', function () {
      setArrow();
    });

    $('body .product-slider .slider-wrap .slide-nav .slide-prev').on('click', function () {
      setArrow();
    });

  });

  setTimeout(function () {
    $('.product-slider .slider-nav .item').matchHeight();
    $('.product-slider .slider-outer .slider-for .item .inner-tab-slider .inner-item .col-four').matchHeight();
  }, 600)

  setTimeout(function () {
    $('.product-slider .slider-wrap').animate({"opacity": 1});
    $('.product-slider .slider-outer').animate({"opacity": 1});
  }, 1000);

})(jQuery);